module.exports = __webpack_public_path__ + "img/login-logo.ac10da86.png";